import { Reference } from '@apollo/client';
import { useCategoryDeleteMutation } from 'lib-knowledge-management-common/graphql';
import { Category } from 'lib-knowledge-management-common/models/types';
import { ampli } from 'lib-shared-tracking';

type MutationFunction = ReturnType<typeof useCategoryDeleteMutation>[0];
type MutationReturnValue = ReturnType<MutationFunction>;
type DeleteFn = (data: { category: Category }) => MutationReturnValue;
type UseCategoryMoveReturnValue = [
  DeleteFn,
  ReturnType<typeof useCategoryDeleteMutation>[1],
];

function useCategoryDelete(): UseCategoryMoveReturnValue {
  const [deleteMutation, mutationResult] = useCategoryDeleteMutation();
  const deleteCategory: DeleteFn = ({ category }) => {
    return deleteMutation({
      variables: {
        categoryId: category.id,
      },
      update(cache) {
        // Remove it from it's parent
        if (category.parent?.id) {
          cache.modify<Category>({
            id: cache.identify(category.parent),
            fields: {
              categories(existingChildRefs = [], { readField }) {
                return existingChildRefs.filter((childRef) => {
                  return category.id !== readField('id', childRef!);
                }) as Reference[];
              },
            },
          });
        }

        // Clean up the actual category
        cache.evict({
          id: cache.identify(category),
        });
      },
    }).then((args) => {
      ampli.knowledgeCategoryDestroyed({ categoryId: category.id });
      return args;
    });
  };

  return [deleteCategory, mutationResult];
}

export default useCategoryDelete;
